
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3g0Pk", function(module, exports) {
$parcel$export(module.exports, "BrowserStorageControlsInit", () => $bd0974be2f016f9b$export$1e5524c82dfa4c29);

var $eJOHy = parcelRequire("eJOHy");

var $lxm51 = parcelRequire("lxm51");

var $gOhYy = parcelRequire("gOhYy");

var $4cTDP = parcelRequire("4cTDP");

var $eXnFk = parcelRequire("eXnFk");
const $bd0974be2f016f9b$export$1e5524c82dfa4c29 = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('jfp-magma-ssr-cookie-cb')) (0, $gOhYy.initControlsOnce)();
        else if ((0, $4cTDP.fg)('fedramp-cookies-controls')) (0, $lxm51.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration'),
            perimeter: (0, $eXnFk.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        });
        else (0, $lxm51.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')
        });
    }, []);
    return null;
};

});
parcelRegister("lxm51", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $cd18b58ee1586452$export$919040c32a62c7db);

var $fFMqJ = parcelRequire("fFMqJ");

var $ebQh8 = parcelRequire("ebQh8");
var $fydPh = parcelRequire("fydPh");
var $lUfMP = parcelRequire("lUfMP");

var $2hlpL = parcelRequire("2hlpL");

var $5Yr8v = parcelRequire("5Yr8v");

var $fdiUc = parcelRequire("fdiUc");

var $li0ek = parcelRequire("li0ek");
const $cd18b58ee1586452$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $fFMqJ.fg)('platform_moonjelly_bsc_master_killswitch')) // Exit if the master killswitch is enabled
    return;
    try {
        (0, $lUfMP.Logger).debug('initializeControls invoked');
        (0, $2hlpL.initializeGlobalState)(args);
        // Exit silently if in SSR context
        if ((0, $fydPh.isSSR)()) return;
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $ebQh8.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $fdiUc.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $2hlpL.getBscGlobalState)().webStorageEnabled;
        if (!isWebStorageControlsEnabled) return;
        await (0, $li0ek.createWebStoragePassthrough)((0, $5Yr8v.WebStorageType).LocalStorage);
        await (0, $li0ek.createWebStoragePassthrough)((0, $5Yr8v.WebStorageType).SessionStorage);
        (0, $lUfMP.Logger).debug('initiizeControls finished');
    } catch (e) {
        (0, $lUfMP.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
};

});
parcelRegister("fdiUc", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $925e026c89dc8a83$export$45a5573b04db016c);

var $lUfMP = parcelRequire("lUfMP");

var $abSbA = parcelRequire("abSbA");
const $925e026c89dc8a83$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $lUfMP.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $abSbA.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("abSbA", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $95aa19bb3bf1d662$export$b7364c41ddbfdb0a);

var $2hlpL = parcelRequire("2hlpL");
var $ebQh8 = parcelRequire("ebQh8");

var $ktDvt = parcelRequire("ktDvt");

var $lUfMP = parcelRequire("lUfMP");

var $5YKyX = parcelRequire("5YKyX");
const $95aa19bb3bf1d662$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $lUfMP.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $ebQh8.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $2hlpL.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $ktDvt.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $2hlpL.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else return;
                    },
                    storageType: (0, $5YKyX.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $lUfMP.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $lUfMP.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("li0ek", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthrough", () => $8815ccd53a47deaf$export$619fe705922e5d61);

var $lUfMP = parcelRequire("lUfMP");

var $i5xqg = parcelRequire("i5xqg");

var $5Yr8v = parcelRequire("5Yr8v");

var $6rKlI = parcelRequire("6rKlI");
const $8815ccd53a47deaf$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $5Yr8v.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $lUfMP.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $i5xqg.BSCIndexedDB).isAvailable) {
        (0, $lUfMP.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $i5xqg.BSCIndexedDB).isBooted) // If we've yet to invoke booting of the IDB service, ensure we do it here.
    await (0, $i5xqg.BSCIndexedDB).boot();
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $6rKlI.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $5Yr8v.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("6rKlI", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $87511c1d0d4df2f3$export$b4469df6294ea6aa);

var $2hlpL = parcelRequire("2hlpL");
var $ebQh8 = parcelRequire("ebQh8");

var $ktDvt = parcelRequire("ktDvt");

var $lUfMP = parcelRequire("lUfMP");

var $5Yr8v = parcelRequire("5Yr8v");

var $5YKyX = parcelRequire("5YKyX");
const $87511c1d0d4df2f3$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $lUfMP.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            (0, $ebQh8.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            try {
                const productName = (0, $2hlpL.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $ktDvt.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ()=>{
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $2hlpL.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else return;
                    },
                    storageType: storageType === (0, $5Yr8v.WebStorageType).LocalStorage ? (0, $5YKyX.CategoryStorageType).LocalStorage : (0, $5YKyX.CategoryStorageType).SessionStorage,
                    productName: productName
                });
            } catch (e) {
                (0, $lUfMP.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType
                    }
                });
            }
        } catch (e) {
            (0, $lUfMP.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };

});



parcelRegister("gOhYy", function(module, exports) {
$parcel$export(module.exports, "initControlsOnce", () => $d1edc620a3250b22$export$1120113854b04415);

var $lxm51 = parcelRequire("lxm51");

var $4cTDP = parcelRequire("4cTDP");

var $eXnFk = parcelRequire("eXnFk");

var $SvJbY = parcelRequire("SvJbY");
let $d1edc620a3250b22$var$initializeControlsPromise = null;
function $d1edc620a3250b22$export$1120113854b04415() {
    if (!$d1edc620a3250b22$var$initializeControlsPromise) {
        if ((0, $4cTDP.fg)('fedramp-cookies-controls')) $d1edc620a3250b22$var$initializeControlsPromise = (0, $lxm51.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration'),
            perimeter: (0, $eXnFk.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        });
        else $d1edc620a3250b22$var$initializeControlsPromise = (0, $lxm51.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')
        });
    }
    return $d1edc620a3250b22$var$initializeControlsPromise;
}
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $d1edc620a3250b22$var$initializeControlsPromise = null;
});

});



//# sourceMappingURL=async-browser-storage-controls-init.97dcc0eb.js.map
